export class TableDialogModel {
  constructor(type: string, data: any) {
      this.Type = type;
      this.Data = data;
  }
  public Type: string;
  public Data: any;
}
